<template>
	<el-dialog :title="title" :visible="show" width="780px" custom-class="sample-dialog" append-to-body :before-close="() => $emit('update:show', false)">
		<el-divider />
		<div class="dialog-container">
			<ul class="hover-ul">
				<li v-for="(item, index) in tempList" :key="index" @click="() => (chooseTempId = chooseTempId === item.id ? null : item.id)">
					<div class="cont" :class="{ actont: chooseTempId === item.id }">
						<img class="icon" :src="chooseTempId !== item.id ? require('@comm/images/document-conversion/electronic/checkbox.png') : require('@comm/images/document-conversion/electronic/checked.png')" />
						<img :src="item.src" />
						<div class="hover-box">
							<p><el-button size="mini" class="temp-btn" @click="handleViewFile(item)">查看文件</el-button></p>
							<p><el-button size="mini" class="temp-btn" @click="handleDownloadFile(item)">下载文件</el-button></p>
						</div>
					</div>
					<p class="name">{{ item.name }}</p>
				</li>
				<li></li>
			</ul>
		</div>
		<el-divider />
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" size="small" :disabled="!chooseTempId" @click="confirm">确定</el-button>
			<el-button size="small" @click="$emit('update:show', false)">取消</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { downloadXML } from "@comm/api/document-conversion/issue";
import { exportBlobData } from "@comm/utils/tools";

export default {
	name: "SampleDialog",
	props: {
		title: { type: String, default: "" },
		show: { type: Boolean, default: false }
	},
	data() {
		const tmepData = () => {
			const arr = ["电子发票", "电子回单", "电子对账单", "电子客票（高铁）", "航空行程单", "非税票据", "会计凭证"];
			return arr.map((item, index) => ({ id: index + 1, name: item, src: require("@comm/images/document-conversion/electronic/xml.png") }));
		};
		return {
			chooseTempId: "",
			tempList: tmepData()
		};
	},
	watch: {
		show(nVal, oVal) {
			if (nVal) this.chooseTempId = "";
		}
	},
	methods: {
		confirm() {
			const item = this.tempList.filter((item) => item.id === this.chooseTempId)[0];
			this.$emit("confirm", item);
		},
		handleViewFile(item) {
			const { id } = item;
			window.open(`/static/openfile/${id}.xml`, "_blank");
		},
		handleDownloadFile(item) {
			downloadXML({ fileId: item.id }).then((res) => {
				exportBlobData(res);
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.dialog-container {
	user-select: none;
	.hover-ul {
		grid-column-gap: 46px;
		li {
			width: 148px;
			height: 180px;
		}
		.hover-box {
			padding-top: 30px;
			p {
				margin: 10px 0;
			}
		}
		.name {
			font-size: 16px;
		}
	}
}
.dialog-footer {
	button {
		margin: 0 6px;
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/electronicDec/components/SampleDialog.vue